import React from 'react';
import { Paper, Tabs, Tab } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { ConditionalWrapper } from '../../GenericUI/ConditionalWrapper';
const classes = {
    root: {
        backgroundColor: '#f6f6f6',
    },
    chip: {
        marginRight: '8px',
        marginBottom: '8px',
        backgroundColor: '#f5f5f5',
    },
    tab: {
        borderBottom: '1px solid #BDBDBD',
        minHeight: '100px',
        backgroundColor: '#FBFBFB',
    },
    selectedTab: {
        minHeight: '100px',
        backgroundColor: 'white',
    },
    iconChecked: {
        color: '#26a22a',
    },
    icon: {
        color: '#bdbdbd',
    },
};
const FacetSelectionSideBar = ({ projectType, onFacetClick, searchQuery, }) => {
    const [activeTab, setActiveTab] = React.useState(0);
    if (!projectType) {
        return React.createElement("div", null, "Property [projectType] not specified");
    }
    const steps = projectType.mainFacets;
    if (!steps) {
        return React.createElement("div", null, "Property [projectType.mainFacets] not specified");
    }
    const handleStep = (tab) => {
        setActiveTab(tab);
        onFacetClick(projectType.mainFacets[tab]);
    };
    const tabCompleted = (itemlist, facet) => {
        return itemlist.filter((item) => item.facetId === facet.id).length > 0;
    };
    return (React.createElement("div", { style: classes.root },
        React.createElement(Paper, { square: true, style: { backgroundColor: '#eeeeee' } },
            React.createElement(Tabs, { orientation: 'vertical', value: activeTab, indicatorColor: 'primary', textColor: 'primary', centered: true }, steps.map((facet, index) => (React.createElement(ConditionalWrapper, { key: facet.id, condition: index === activeTab, 
                // eslint-disable-next-line react/no-unstable-nested-components
                wrapper: (children) => (React.createElement(Paper, { elevation: 6, style: {
                        color: 'darkblue',
                        textAlign: 'center',
                        minWidth: '160px',
                    } }, children)) },
                React.createElement(Tab, { key: facet.id, onClick: () => {
                        handleStep(index);
                    }, label: facet.title, sx: index === activeTab ? classes.selectedTab : classes.tab, icon: tabCompleted(searchQuery.selectedItems, facet) ? (React.createElement(CheckCircleIcon, { sx: classes.iconChecked })) : (React.createElement(CheckCircleOutlineIcon, { sx: classes.icon })) }))))))));
};
export default FacetSelectionSideBar;
